"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.performDownload = exports.getDocumentsWithChildren = exports.getCurrentDateMMDDYYYY_HHMM = exports.getChilds = exports.getBlobTree = void 0;
var _constants = require("util/constants");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var performDownload = exports.performDownload = function performDownload(content, fileType, fileName) {
  var link = document.createElement("a");
  link.href = globalThis.URL.createObjectURL(content);
  link.download = fileName !== null && fileName !== void 0 ? fileName : "KB_files_".concat(getCurrentDateMMDDYYYY_HHMM(), ".").concat(fileType);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
var getBlobTree = exports.getBlobTree = function getBlobTree(blobs) {
  //Let's loop the blob list
  var tree = [];
  blobs.forEach(function (blob) {
    var actualId = null;
    var actualPath = "";
    if (blob.path !== "") {
      //Let's split the path property
      var splittedPath = blob.path.split("/").filter(function (path) {
        return path !== "";
      });
      var _loop = function _loop() {
        var folder = splittedPath[index];
        //Lets find if the actual folder exists
        actualPath += (actualPath === "" ? "" : "/") + folder;
        var id = "".concat(actualId, "-").concat(folder, "-").concat(index);
        var folderExists = tree.find(function (aF) {
          return aF.id === id;
        });
        if (!folderExists) {
          //If not exists, let's add it
          var folderToCreate = {
            documentName: folder,
            file_name: folder,
            indexing_status: "SUCCESS",
            fileType: _constants.TYPE_FOLDER,
            category: blob.category,
            id: id,
            metadata: "",
            path: actualPath,
            previewUrl: "",
            uploaded: blob.uploaded,
            uploadedBy: blob.uploadedBy,
            url: "",
            child: [],
            fileAlias: "",
            folderSource: "",
            source: "",
            file_extension: "1.".concat(_constants.TYPE_FOLDER),
            uuid: id,
            parentId: actualId
          };
          tree.push(folderToCreate);
        } else if (!folderExists.category.includes(blob.category)) {
          folderExists.category += " | " + blob.category;
        }
        //Let's add the blob to the folder
        actualId = id;
      };
      for (var index = 0; index < splittedPath.length; index++) {
        _loop();
      }
    }
    tree.push(_objectSpread(_objectSpread({}, blob), {}, {
      parentId: actualId
    }));
  });
  //Lets check the source of the files
  var _iterator = _createForOfIteratorHelper(tree.filter(function (t) {
      return t.fileType === _constants.TYPE_FOLDER && t.source === "";
    }).sort(function (a, b) {
      // Si a tiene parentId null y b no, a va al final (retorna 1)
      if (a.parentId === null && b.parentId !== null) return 1;
      // Si b tiene parentId null y a no, b va al final (retorna -1)
      if (b.parentId === null && a.parentId !== null) return -1;
      // Si ambos tienen parentId null, mantener orden
      if (a.parentId === null && b.parentId === null) return 0;
      // Si ambos tienen parentId no null, usar el ordenamiento original
      return (a.parentId || "") < (b.parentId || "") ? 1 : -1;
    })),
    _step;
  try {
    var _loop2 = function _loop2() {
      var t = _step.value;
      //We need to get all the children of this folder
      var children = tree.filter(function (c) {
        return c.parentId === t.id;
      });
      t.source = _constants.SOURCE_MANUAL;
      if (children.some(function (c) {
        return c.source === _constants.SOURCE_TEAMS;
      })) {
        t.source = _constants.SOURCE_TEAMS;
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop2();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return tree.sort(function (a, b) {
    if (a.fileType === _constants.TYPE_FOLDER && b.fileType !== _constants.TYPE_FOLDER) return -1;
    if (a.fileType !== _constants.TYPE_FOLDER && b.fileType === _constants.TYPE_FOLDER) return 1;
    return a.documentName.localeCompare(b.documentName);
  });
};
var _getChilds = exports.getChilds = function getChilds(parentDocument, allDocuments) {
  var children = [];

  // Find all direct children
  var directChildren = allDocuments.filter(function (doc) {
    return doc.parentId === parentDocument.id;
  });

  // Add direct children and recursively get their children
  var _iterator2 = _createForOfIteratorHelper(directChildren),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var child = _step2.value;
      children.push(child);
      // Recursively get children of this child
      var grandChildren = _getChilds(child, allDocuments);
      children.push.apply(children, _toConsumableArray(grandChildren));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return children;
};
var addDocumentWithChildren = function addDocumentWithChildren(doc, allDocuments, result, processedIds) {
  result.push(doc);
  processedIds.add(doc.id);
  if (doc.fileType !== _constants.TYPE_FOLDER) return;
  var _iterator3 = _createForOfIteratorHelper(_getChilds(doc, allDocuments)),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var child = _step3.value;
      if (!processedIds.has(child.id)) {
        result.push(child);
        processedIds.add(child.id);
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
};

/**
 * Gets documents by IDs and recursively includes all children if the document is a folder
 * @param ids - Array of document IDs to retrieve
 * @param allDocuments - Array of all available documents
 * @returns Array of documents including the requested documents and all their descendants
 */
var getDocumentsWithChildren = exports.getDocumentsWithChildren = function getDocumentsWithChildren(ids, allDocuments) {
  var result = [];
  var processedIds = new Set();
  var _iterator4 = _createForOfIteratorHelper(ids),
    _step4;
  try {
    var _loop3 = function _loop3() {
      var id = _step4.value;
      var doc = allDocuments.find(function (d) {
        return d.id === id;
      });
      if (doc && !processedIds.has(doc.id)) {
        addDocumentWithChildren(doc, allDocuments, result, processedIds);
      }
    };
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      _loop3();
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return result;
};
var getCurrentDateMMDDYYYY_HHMM = exports.getCurrentDateMMDDYYYY_HHMM = function getCurrentDateMMDDYYYY_HHMM() {
  var now = new Date();
  var mm = String(now.getMonth() + 1).padStart(2, "0");
  var dd = String(now.getDate()).padStart(2, "0");
  var yyyy = now.getFullYear();
  var hh = String(now.getHours()).padStart(2, "0");
  var min = String(now.getMinutes()).padStart(2, "0");
  return "".concat(mm).concat(dd).concat(yyyy, "_").concat(hh).concat(min);
};